import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="main_footer"
      style={{ backgroundImage: "url(/images/background/footer-bg.jpg)" }}
    >
      <div className="container">
        <div className="footer-top-outer">
          <div className="row">
            {/* About Widget */}
           

            <div className="col-12 col-md-3">
  <div className="footer_widget footer_about_widget">
    <figure className="footer_widget_logo">
      <a href="index-2.html">
        <img src="/images/logo.jpg" alt="Footer Logo" />
      </a>
    </figure>
    <p>
      Lotus Cabs is a reliable and customer-focused cab service provider offering safe, comfortable, and affordable travel solutions across Pune, Mumbai, and surrounding regions. We specialize in local city rides, airport transfers, outstation trips, and one-way travel, ensuring timely service and well-maintained vehicles for a smooth journey.
    </p>
    <ul className="footer-info-list">
      <li>
        <i className="fa fa-envelope text-warning" aria-hidden="true"></i>{" "}
        <a href="mailto:booking@lotuscab.com">booking@lotuscab.com</a>
      </li>
      <li>
        <i className="fa fa-phone text-warning" aria-hidden="true"></i>{" "}
        <a href="tel:918767592195">+91 8767592195</a>
      </li>
      <li>
        <i className="fa fa-phone text-warning" aria-hidden="true"></i>{" "}
        <a href="tel:919172145909">+91 9172145909</a>
      </li>
    </ul>

{/* Social Media Icons */}
      <div className="col-auto">
        <ul className="d-flex mb-0">
          
          <li className="px-2">
            <a href="https://www.instagram.com/lotuscab_/" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-instagram"></i>
            </a>
          </li>

          <li className="px-2">
            <a href="https://facebook.com/lotuscab" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-facebook-f"></i>
            </a>
          </li>

          <li className="px-2">
      <a href="https://www.linkedin.com/in/lotus-cab-a680823b3/?skipRedirect=true" target="_blank" rel="noreferrer" className="text-white">
        <i className="fab fa-linkedin-in"></i>
      </a>
    </li>

          <li className="px-2">
            <a href="https://x.com/lotuscab1" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-twitter"></i>
            </a>
          </li>

        </ul>
      </div>

  </div>

  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1383730.8518505222!2d72.31812776812657!3d19.240470748091894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c3cb5cdd86070e5%3A0x6991a7b95cc1d68a!2sLotus%20Cab!5e1!3m2!1sen!2sin!4v1771048829843!5m2!1sen!2sin" width="100%" height="250px" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>




</div>


            {/* Resources Widget */}
            <div className="col-12 col-md-3">
              <div className="footer_widget footer_resources_widget">
                <h4 className="footer_widget_title">Services</h4>
          <Link className="mx-md-2 d-block" to="/Pune-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Pune Taxi Fare</Link>

<Link className="mx-md-2 d-block" to="/Pune-Outstation-Taxi-Hire"><i className="fa fa-car darkcolor"></i> Pune Outstation Taxi Hire</Link>

<Link className="mx-md-2 d-block" to="/Pimpri-Chinchwad-Online-Cab"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad Online Cab</Link>

<Link className="mx-md-2 d-block" to="/Best-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Best Cab Service in Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-One-Way-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mumbai One Way Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Nasik-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Nasik Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Mahabaleshwar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Lonavala-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab Booking</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Lavasa-City-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Lavasa City Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-Airport-to-Bhimashankar-Cabs"><i className="fa fa-car darkcolor"></i> Pune Airport to Bhimashankar Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Indore-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Indore Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Konkan-Darshan-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-Cab-Fare"><i className="fa fa-car darkcolor"></i> Pune Cab Fare</Link>

<Link className="mx-md-2 d-block" to="/Outstation-Taxi-Service-Pune"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Panchgani-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cab Booking</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-International-Airport-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Mumbai International Airport Taxi</Link>

<Link className="mx-md-2 d-block" to="/Ashtavinayak-Darshan-Cab-Package"><i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Cab Package</Link>

<Link className="mx-md-2 d-block" to="/Pune-To-Nagpur-Cabs"><i className="fa fa-car darkcolor"></i> Pune To Nagpur Cabs</Link>

<Link className="mx-md-2 d-block" to="/Cab-Service-in-Kharadi"><i className="fa fa-car darkcolor"></i> Cab Service in Kharadi</Link>

<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Hinjewadi-Pune"><i className="fa fa-car darkcolor"></i> Taxi Service in Hinjewadi Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Gujarat-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Travel-Agents-in-Pune"><i className="fa fa-car darkcolor"></i> Travel Agents in Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Thane-Cab"><i className="fa fa-car darkcolor"></i> Pune to Thane Cab</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Bangalore-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Taxi Service</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Goa Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Ajanta-Ellora-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Ajanta Ellora Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Satara-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Satara Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Pune Airport Cabs</Link>

<Link className="mx-md-2 d-block" to="/Cabs-Services-Near-Me"><i className="fa fa-car darkcolor"></i> Cabs Services Near Me</Link>

<Link className="mx-md-2 d-block" to="/Corporate-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Service in Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cab</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Pandharpur-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Taxi</Link>

<Link className="mx-md-2 d-block" to="/Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune</Link>

              </div>
            </div>

          



 <div className="col-12 col-md-3">
              <div className="footer_widget footer_newsletter_widget">
                <h4 className="footer_widget_title">Services</h4>

<Link className="mx-md-2 d-block" to="/Innova-Crysta-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Innova-Cabs-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Cabs on Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Volkswagen-Vento-On-Rent"><i className="fa fa-car darkcolor"></i> Volkswagen Vento On Rent</Link>

<Link className="mx-md-2 d-block" to="/Swift-Dzire-On-Rent-In-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent In Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Imagica-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Imagica Taxi</Link>

<Link className="mx-md-2 d-block" to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Ertiga-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Kia-Carens-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Kia Carens On Rent in Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Sambhaji-Nagar-Taxi-fare"><i className="fa fa-car darkcolor"></i> Pune to Sambhaji Nagar Taxi fare</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Ganpatipule-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Ganpatipule Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Harihareshwar-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Pune to Harihareshwar Taxi Fare</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Alibag-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Alibag Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Panvel-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Panvel Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Hyderabad-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-5-Jyotrilinga-Cab"><i className="fa fa-car darkcolor"></i> Pune to 5 Jyotrilinga Cab</Link>

<Link className="mx-md-2 d-block" to="/Cab-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Cab Booking in Pune</Link>

<Link className="mx-md-2 d-block" to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link>

<Link className="mx-md-2 d-block" to="/Explorer-pan-India-cab-service-from-Pune"><i className="fa fa-car darkcolor"></i> Explorer pan India cab service from Pune</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-Darshan-Cabs-Service"><i className="fa fa-car darkcolor"></i> Mumbai Darshan Cabs Service</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Shirdi-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Shirdi Cabs</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-Airport-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cabs</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Mahabaleshwar-Taxi"><i className="fa fa-car darkcolor"></i> Mumbai to Mahabaleshwar Taxi</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Konkan Darshan Cab</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Nashik-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Nashik Cab</Link>


<Link className="mx-md-2 d-block" to="/Mumbai-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Airport Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Outstation Cabs</Link>

<Link className="mx-md-2 d-block" to="/Online-Taxi-Booking-Mumbai"><i className="fa fa-car darkcolor"></i> Online Taxi Booking Mumbai</Link>

<Link className="mx-md-2 d-block" to="/Outstation-Taxi-Service-in-Thane"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service in Thane</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-5-Jyotirlinga-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to 5 Jyotirlinga Darshan Cab</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Kolhapur-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Kolhapur Cabs</Link>

<Link className="mx-md-2 d-block" to="/Cheapest-Cab-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Cheapest Cab Service in Mumbai</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Ashtavinayak-Darshan-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Ashtavinayak Darshan Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Hadapsar"><i className="fa fa-car darkcolor"></i> Taxi Service in Hadapsar</Link>

<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Lohegaon"><i className="fa fa-car darkcolor"></i> Taxi Service in Lohegaon</Link>






              </div>
            </div>










            {/* Newsletter Widget */}
            <div className="col-12 col-md-3">
              <div className="footer_widget footer_newsletter_widget">
              
                <h4 className="footer_widget_title">Services</h4>

<Link className="mx-md-2 d-block" to="/Cab-Service-in-Viman-Nagar"><i className="fa fa-car darkcolor"></i> Cab Service in Viman Nagar</Link>

<Link className="mx-md-2 d-block" to="/One-Way-Cab-Pune"><i className="fa fa-car darkcolor"></i> One Way Cab Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Outstations-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Outstations Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Matheran-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Matheran Cabs</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-5-Jyotirlinga-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to 5 Jyotirlinga Darshan Cab</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Aurangabad-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Nashik-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nashik Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Alibaug-Cab"><i className="fa fa-car darkcolor"></i> Pune to Alibaug Cab</Link>

<Link className="mx-md-2 d-block" to="/Goa-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Goa to Pune Cabs</Link>

<Link className="mx-md-2 d-block" to="/Innova-Crysta-Cab-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta Cab in Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Ashtavinayak-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Cabs</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-Outstation-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai Outstation Cab Booking</Link>

<Link className="mx-md-2 d-block" to="/Cab-Service-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Navi Mumbai</Link>

<Link className="mx-md-2 d-block" to="/Navi-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab</Link>


<Link className="mx-md-2 d-block" to="/Innova-Crysta-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Mumbai</Link>

<Link className="mx-md-2 d-block" to="/Ertiga-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Mumbai</Link>

<Link className="mx-md-2 d-block" to="/Cab-Service-in-Thane"><i className="fa fa-car darkcolor"></i> Cab Service in Thane</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Alibaug-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Alibaug Cab</Link>

<Link className="mx-md-2 d-block" to="/Navi-Mumbai-International-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Navi Mumbai International Airport cabs</Link>


<Link className="mx-md-2 d-block" to="/Goa-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Goa to Pune Cab Service</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Innova-Rental"><i className="fa fa-car darkcolor"></i> Pune to Goa Innova Rental</Link>

<Link className="mx-md-2 d-block" to="/Goa-to-Pimpri-Chinchwad-Cab"><i className="fa fa-car darkcolor"></i> Goa to Pimpri Chinchwad Cab</Link>

<Link className="mx-md-2 d-block" to="/Goa-to-Pune-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Goa to Pune One Way Cab</Link>

<Link className="mx-md-2 d-block" to="/Goa-to-Pune-Taxi"><i className="fa fa-car darkcolor"></i> Goa to Pune Taxi</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Goa Taxi</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Cab-Package"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab Package</Link>


<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Taxi-Fare-One-Way"><i className="fa fa-car darkcolor"></i> Pune to Goa Taxi Fare One Way</Link>

<Link className="mx-md-2 d-block" to="/Pimpri-Chinchwad-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad to Goa Cab</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Goa Taxi Service</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Ertiga-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Goa Ertiga Cab Booking</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Tour-Packages-for-Family"><i className="fa fa-car darkcolor"></i> Pune to Goa Tour Packages for Family</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-2-Days-Package"><i className="fa fa-car darkcolor"></i> Pune to Goa 2 Days Package</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-3-Days-Package"><i className="fa fa-car darkcolor"></i> Pune to Goa 3 Days Package</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Innova-Cab"><i className="fa fa-car darkcolor"></i> Pune to Goa Innova Cab</Link>

<Link className="mx-md-2 d-block" to="/Goa-Packages-from-Pune-for-Family"><i className="fa fa-car darkcolor"></i> Goa Packages from Pune for Family</Link>

              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom-outer">
          <div className="copyright">
             <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Lotus cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
          </div>
  
        </div>
      </div>
    </footer>
  );
};

export default Footer;
